module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"logOut":"Log out","myAccount":"My account","addTeammates":"Add teammates","findNewTalents":"Find new talents"}}}')
  delete Component.options._Ctor
}
